/*globals $*/
'use strict';

const getValidationFunctions = () => import("./validate");

document.addEventListener('DOMContentLoaded', function () {
   const submitButton = document.querySelector('#webcooking__contact-form #webcooking__contact_submit-button');
   if (submitButton) {
      submitButton.addEventListener('click', function (e) {
         e.preventDefault();
         getValidationFunctions().then(validateModule => {
            validateModule.validateContactForm();
         });
      });
   }
});
